module.exports = __webpack_public_path__ + "media/beep.07b57229.wav";